import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Recent Statistics"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7" }, "More than 400 new members")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, {
              src: "/media/icons/duotune/general/gen024.svg",
              "aria-hidden": "true"
            })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_apexchart, {
        type: "bar",
        options: _ctx.options,
        series: _ctx.series
      }, null, 8, ["options", "series"])
    ])
  ], 2))
}